import { operatorsEnum } from '../enums/operators.enum';

export class RelatedConceptModel {
    value: string;
    type: operatorsEnum;
    selected: boolean;
    disabled: boolean;

    constructor(value: string) {
        this.value = value;
        this.type = operatorsEnum.and;
        this.selected = null;
    }
}
